exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.article-item-container>div img[data-v-e8ca851c]{height:240px;width:100%;object-fit:cover\n}", ""]);

// exports
